import { useEffect, useState } from 'react'
import { Container, BgModal, ModalContent } from './styles'

import { t } from '../../../adapters/translate/translate'
import Loading from '../../../components/loadings/simple'
import { Row } from '../../ui/layout'
import { checkGames, makeCurrentUserByPlayer } from '../../../../main/usecases/users/users-factory'
import { setUser } from '../../../utils/storage/user'
import { clearGame } from '../../../utils/storage_helpers'
import { useGame } from '../../../contexts'

type Props = {
    onAction?: () => void;
  }

const SelectGameModal = ({ onAction }: Props) => {
  useEffect(() => {
    (async function loadGames () {
      setIsLoading(true)

      try {
        const gamesModel = await checkGames().load()
        const players: Array<any> = gamesModel['hydra:member']

        const games: Array<Object> = players.map((p: any) => {
          return {
            playerId: p.player_id,
            title: p.game.name
          }
        })

        setGames(games)
      } catch (error: any) {
        console.error(t(error.code, error.message))
      } finally {
        setIsLoading(false)
      }
    })()
  }, [])

  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [games, setGames] = useState<any>([])
  const { setPoints } = useGame()

  const handleSelectGame = async (playerId: number) => {
    setIsLoading(true)

    try {
      const user = await makeCurrentUserByPlayer(playerId).load()
      user.multiGames = true

      setUser(user)
      setPoints(user.points)
      clearGame()

      window.location.href = '/'
    } catch (error: any) {
      console.error(t(error.code, error.message))
    }
  }

  return (
    <Container>
    <BgModal />
    <ModalContent>
      <div className='title'>
        <h2>
          {t('Select a game')}
        </h2>
      </div>

      { isLoading
        ? <Loading />
        : (
            <Row>
                {games.map((game: any) => (
                <button
                    key={game.playerId}
                    onClick={() => { handleSelectGame(game.playerId) }}
                    className="btn btn-primary btn-block m-3"
                    style={{ marginTop: 15 }}
                >
                    { game.title }
                </button>
                ))}
            </Row>
          )
        }

      <Row>
        <button
            onClick={onAction }
            className="btn btn-outline btn-block m-3"
            style={{ marginTop: 30, background: 'transparent' }}
        >
            {t('Close')}
        </button>

        </Row>
    </ModalContent>
  </Container>
  )
}

export default SelectGameModal
